var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVismaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "112px",
    height: "21px",
    viewBox: "0 0 112 21",
    style: {
      enableBackground: "new 0 0 112 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E70641;}\n\t.st1{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LABEL"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.5,0c6.1,0.5,12.8,3.6,16.6,8c4.9,5.6,3.2,11.2-3.8,12.5c-7,1.3-16.6-2.2-21.5-7.8 c-3.7-4.3-3.6-8.6-0.3-11L22,16.1L11.5,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.4,20.5l-2.4-9.8c-0.4-1.2-0.5-2.3-0.7-3.5h-0.1c-0.2,1.2-0.3,2.4-0.6,3.5l-2.5,9.8h-4.2l5.7-20.4h3.3 l5.9,20.4H107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.9,0.1l2.4,9.8c0.4,1.2,0.5,2.3,0.7,3.5h0.1c0.2-1.2,0.3-2.4,0.6-3.5l2.5-9.7h4.2l-5.7,20.4h-3.3 L38.6,0.1H42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.5,0.1v20.4h-4V0.1H60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.3,0.1l2,12.1h0.1L87,0.1h5.4l2.1,20.4h-4.1l-1-14.7h-0.1l-0.7,5L87,20.5h-3.1l-2-9.8l-0.7-4.5V5.8h-0.1 l-0.6,14.7h-4.3L78,0.1H83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.5,0.1c-0.7,0.5-1.2,1.3-1.6,2.2C67.9,4.8,69,6.8,70,8.5c0.1,0.3,0.3,0.5,0.4,0.8 c2.2,3.7,3,6.5,1.4,10.4c-0.1,0.3-0.4,0.8-0.4,0.8h-4.9c0.6-0.4,1.2-1.1,1.5-1.9c1.1-2.7-0.2-5.2-1.5-7.5 c-1.5-2.9-3.1-5.8-1.4-9.9c0.2-0.4,0.5-1,0.5-1H70.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVismaLogo);
export default __webpack_public_path__ + "static/media/visma-logo.03c974ca05405cdd1e663a608f9a43ff.svg";
export { ForwardRef as ReactComponent };